// src/maintenance/components/UploadedView.js
import React from 'react';
import { useRecordContext } from 'react-admin';
import { Card, CardContent, Typography, Alert } from '@mui/material';
import ValidationView from './ValidationView';

const UploadedView = () => {
  const record = useRecordContext();
  
  return (
    <>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Step 2: Review Changes
          </Typography>
          
          <Alert severity="warning">
            Review all changes below carefully before processing.
            Resolve any conflicts that are highlighted.
          </Alert>
        </CardContent>
      </Card>
      
      <ValidationView />
    </>
  );
};

export default UploadedView;